// The opening's name for a library row, from the game's PGN headers. The rule
// lives in `@chess/api-games/filter`, which the library filter also uses to
// match openings, so a row and the filter can never name a game differently.
import { openingNameOf, pgnHeaders } from '@chess/api-games/filter';

export { pgnHeaders };

/** The opening's name, or undefined when the PGN names none. */
export function openingName(pgn: string): string | undefined {
  return openingNameOf(pgn);
}
